package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.list

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Floor
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.checkout.getArrowImg
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun FloorItem(
    isExpandAll: Boolean,
    windowSizeMode: WindowSizeModeEnum,
    floor: Floor?,
    content: @Composable () -> Unit,
    onFloorClick: () -> Unit,
)
{
    val isHovered= remember{ mutableStateOf(false) }

    val isExpanded= remember{ mutableStateOf(false) }
    LaunchedEffect(isExpandAll){
        isExpanded.value=isExpandAll
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(
                Dimen.lowBorderRadius,
            )
            .border(
                width = Dimen.smallThickness,
                color = Theme.ActionDisabledBackground.rgb,
                style = LineStyle.Solid,
            )
            .margin(
                top = Dimen.mediumPadding,
            )
            .cursor(Cursor.Pointer)
            .onClick{
                event: SyntheticMouseEvent -> event.stopPropagation()
            },
        horizontalAlignment = Alignment.End
    ) {


        Box(
            modifier = Modifier
                .rippleEffect {
                    onFloorClick()
                    isExpanded.value=!isExpanded.value
                }
                .fillMaxWidth()
                .backgroundColor(
                    if (isHovered.value) Theme.PrimaryStatesHover.rgb
                    else Theme.Transparent.rgb
                )
                .onMouseOver {isHovered.value=true}
                .onMouseLeave { isHovered.value=false }
                .padding(
                    left = Dimen.largePadding,
                    right = Dimen.normalPadding
                )
                .boxShadow(color = Theme.ActionDisabledBackground.rgb)
                .height(Dimen.checkOutItemHeight),
        )
        {


            Row(
                modifier = Modifier
                    .fillMaxHeight()
                    .align(Alignment.CenterStart)
                    .margin(left = Dimen.mediumPadding),
                verticalAlignment = Alignment.CenterVertically,
            )
            {
                Box(
                    modifier = Modifier
                        .fillMaxHeight()
                ){

                    VectorIcon(
                        modifier = Modifier
                            .align(Alignment.CenterStart),
                        pathData = Res.PathIcon.floor,
                        color = Theme.TextDisabled.hex,
                        height =Dimen.normalIconSize ,
                        width =Dimen.normalIconSize ,
                    )

                    if (!floor?.rooms.isNullOrEmpty()){
                        Box(
                            modifier = Modifier
                                .align(Alignment.BottomCenter)
                                .visibility(
                                    if(isExpanded.value) Visibility.Visible
                                    else Visibility.Hidden
                                )
                                .zIndex(Constants.ZIndex.normalZIndex)
                                .height(Dimen.restaurantItemLineHeight)
                                .backgroundColor(Theme.TextDisabled.rgb)
                                .width(Dimen.smallThickness)
                        )

                    }

                }



                SpanText(
                    text = "${floor?.typename} ${floor?.number}",
                    modifier = Modifier
                        .margin(left = Dimen.mediumPadding)
                        .fontWeight(FontWeight.Normal)
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(FontSizes.mediumFontSize)
                        .color(Theme.TextPrimary.rgb),
                )
            }





            Spacer()



            VectorIcon(
                modifier = Modifier
                    .onClick {
                        isExpanded.value=!isExpanded.value
                    }
                    .align(Alignment.CenterEnd),
                width = Dimen.mediumIconSize,
                height = Dimen.mediumIconSize,
                pathData = getArrowImg(expanded = isExpanded.value),
                color = Theme.ActionActive.hex
            )





        }


        if (isExpanded.value){
            Column(
                modifier = Modifier.fillMaxWidth() ,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                content()
            }
        }


    }


}